<template>
  <div>
    <div class="tittle">
      <p class="spanflex">
         <span @click="clickspan1()" :class="span1_show ==1 ?'red':'nored'"
          style="margin-left:5px;display:inline-block;height:30px;cursor:pointer;margin-left:30px; position: relative;">
          基本信息 <span v-show="span1_show ==1" class="redspan"></span>
        </span>
        <span @click="zxgsKzxx()" :class="span1_show ==2 ?'red':'nored'"
          style="margin-left:200px;display:inline-block;height:30px;cursor:pointer; position: relative; ">
          扩展信息 <span v-show="span1_show ==2" class="redspan"></span>
        </span>
        <span @click="zxgsDpzy()" :class="span1_show ==3 ?'red':'nored'"
          style="margin-left:200px;display:inline-block;height:30px;cursor:pointer; position: relative; ">
          店铺主页 <span v-show="span1_show ==3" class="redspan"></span>
        </span>
      </p>
      <!-- <span class="wei" v-show="span1_show"></span>
      <span class="yi"  v-show="span2_show"></span>-->
    </div>
    <extend v-show="span1_show ==2" ref="extend" @changespanshow = "changespanshow"
     @isaddfun ="isaddfun" :isadd="isadd"/>
    <homepagezxgs v-show="span1_show ==3" ref="homepagezxgs" @changespanshow = "changespanshow"/>
  </div>
</template>
<script>
import extend from "../storeManagement/extend.vue";
import homepagezxgs from "../storeManagement/homepagezxgs.vue";
export default {
  name: "compant",
  data() {
    return {
      span1_show: 1,
      isadd:true,
    };
  },
  methods: {
    changespanshow(val){
     this.span1_show = val
    },
    isaddfun(val){
     this.isadd = val
    
    },
    clickspan1() {
      if(this.isadd){
       return false
      }
      this.span1_show = 1;
    },
    // 装修公司 - 扩展信息
    zxgsKzxx() {
      this.span1_show = 2;
       if(this.$route.query.type == 2){
       this.$refs.extend.init()
     }
    },
    // 装修公司 - 店铺主页
    zxgsDpzy() {
        if(this.isadd){
       return false
      }
      this.span1_show = 3;
       if(this.$route.query.type == 2){
       this.$refs.homepagezxgs.init()
     }
    },
    clickspan4() {
      this.span1_show = 4;
     
    },
    clickspan5() {
      this.span1_show = 5;
    },
  },
  mounted() {
    if(this.$route.query.type == 1){
       this.span1_show = 2

    }
    if(localStorage.companyId !=""){
      this.isadd = false
    }
  },
  components: {
    extend,
    homepagezxgs
  }
};
</script>
<style scoped>
.spanflex {
  display: flex;
}
.red {
  width: 80px;
  height: 100px;
  color: #F56C6C;
  text-align: center;
  line-height: 30px;
  font-size: 17px;
  font-weight: 600;
}
.redspan {
  background: #F56C6C;
  width: 130px;
  height: 2px;
  display: block;
  position: absolute;
  top: 40px;
  left: -23px;
}
.nored {
  width: 80px;
  height: 100px;
  text-align: center;
  line-height: 30px;
  font-size: 17px;
  font-weight: 500;
}
</style>


// WEBPACK FOOTER //
// compant.vue?732a7860